var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddFilterBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.00037H7V1.00037C7 0.73515 6.89464 0.480796 6.70711 0.293259C6.51957 0.105723 6.26522 0.000366211 6 0.000366211C5.73478 0.000366211 5.48043 0.105723 5.29289 0.293259C5.10536 0.480796 5 0.73515 5 1.00037V5.00037H1C0.734784 5.00037 0.48043 5.10572 0.292893 5.29326C0.105357 5.4808 0 5.73515 0 6.00037C0 6.26558 0.105357 6.51994 0.292893 6.70747C0.48043 6.89501 0.734784 7.00037 1 7.00037H5V11.0004C5 11.2656 5.10536 11.5199 5.29289 11.7075C5.48043 11.895 5.73478 12.0004 6 12.0004C6.26522 12.0004 6.51957 11.895 6.70711 11.7075C6.89464 11.5199 7 11.2656 7 11.0004V7.00037H11C11.2652 7.00037 11.5196 6.89501 11.7071 6.70747C11.8946 6.51994 12 6.26558 12 6.00037C12 5.73515 11.8946 5.4808 11.7071 5.29326C11.5196 5.10572 11.2652 5.00037 11 5.00037Z",
    fill: "#056EE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFilterBlue);
export default __webpack_public_path__ + "static/media/addFilterBlue.6e292c4a16e5b47b053635d799d3c2ac.svg";
export { ForwardRef as ReactComponent };